import type { ArticlePageData } from "@core/SitePresenter/types/ArticlePage";
import safeDecode from "@core/utils/safeDecode";
import ArticleRefService from "@core-ui/ContextServices/ArticleRef";
import holdArticleAnchor from "@core-ui/hooks/holdArticleAnchor";
import { useEffect, useRef } from "react";

const useScrollToArticleAnchor = (data: ArticlePageData) => {
	const Data = useRef<ArticlePageData>();
	const articleRef = ArticleRefService.value;
	const hold = useRef<() => void>(null);

	useEffect(() => {
		if (data === Data.current) return;
		if (!articleRef.current) return;

		const anchorId = window.location.hash.substring(1);
		if (!anchorId) return;

		Data.current = data;
		hold.current?.();
		hold.current = holdArticleAnchor(articleRef.current, safeDecode(anchorId));

		return () => {
			Data.current = null;
			hold.current?.();
			hold.current = null;
		};
	}, [data]);
};

export default useScrollToArticleAnchor;
